/* Core & libraries */
import React, {useEffect, useState} from "react";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import { useGenericApiFetch }  from "../endpoints/base";
import {
  SAFETY_GRID_ENDPOINT,
  SAFETY_MAP_ENDPOINT,
  SAFETY_GET_FLIGHTDETAILS,
  INVITATION_ENDPOINT,
  CHECK_IF_EMAIL_EXISTS_ENDPOINT,
  MANAGE_RESERVATION_ENDPOINT
} from "../endpoints/endpoints";
import {useUserContext} from "../contexts/userContext";
import { useNotificationContext } from "../contexts/notificationContext";
import { useLocaleContext } from "../contexts/localeContext";

/* Components */
/* Styles */

export const useSafetyService = (gridOptions) => {
  const [safetyResponse, setSafetyResponse] = useState({})
  const [mapResponse, setMapResponse] = useState({})
  const { genericApiFetch } = useGenericApiFetch();
  const userDetails = useUserContext();
  const { setNotification } = useNotificationContext();
  const locale = useLocaleContext();

  const companyEntityId = userDetails?.userInfo?.companyInfo?.companyEntityId;
  const providerCode = userDetails?.userInfo?.providerInfo?.providerCode;

  useEffect(() => {
    (async () => {
      await getSafetyList(gridOptions);
    })();
  }, [gridOptions]);

  const getSafetyList = async (options) => {
    if (options) {
      let filters = "";
      if (options.filters) {
        for (const [key, value] of Object.entries(options.filters)) {
          value.map(item => {
            if (item) {
              filters += `${filters ? "," : ""}${key}-${item}`
            }
          })
        }
      }
      options = {
        ...options,
        filters
      }
      getSafetyGridData(options);
      getSafetyMapData({
        ...options,
        page: -1
      });
    }
  }

  const getFlightDetails = async (iDs) => {
    const response = await genericApiFetch({
      url: SAFETY_GET_FLIGHTDETAILS.replace("{bookingId}", iDs.bookingId).replace("{fsegementId}", iDs.fsegmentId),
      method: "GET",
    });

    if (response.success) {
      return response.data;
    }
    
    return false;
  }

  const getReservationLinkDetails = async (bookingId) => {
    const response = await genericApiFetch({
      url: MANAGE_RESERVATION_ENDPOINT.replace("{providerCode}", providerCode?.toLowerCase()).replace("{bookingId}", bookingId),
      method: "GET",
    });

    if (response.success) {
      return response.data;
    }
    
    return false;
  }


  const getSafetyGridData = async (options) => {
    const response = await genericApiFetch({
      url: SAFETY_GRID_ENDPOINT.replace("{companyId}", companyEntityId),
      method: "GET",
      queryParams: options,
      spinner: "safetyGridSpinner"
    });

    if (response.success) {
      setSafetyResponse(response.data);
    } else {
      setSafetyResponse({ results: null });
    }

  }
  const getSafetyMapData = async (options) => {

    const responseMap = await genericApiFetch({
      url: SAFETY_MAP_ENDPOINT.replace("{companyEntityId}", companyEntityId),
      method: "GET",
      queryParams: options,
      spinner: "safetyGridSpinner"
    });

    if (responseMap.success) {
      if (JSON.stringify(responseMap.data) === JSON.stringify(mapResponse)) {
       return
      } 

      setMapResponse(responseMap.data);
    }
  }

  const sendGuestInvite = async (inviteData) => {

    const response = await genericApiFetch({
      url: INVITATION_ENDPOINT.replace("{providerCode}", providerCode?.toLowerCase()),
      method: "POST",
      data : {
        ...inviteData,
        companyEntityId: companyEntityId,
        locale: locale
      },
      spinner: "inviteGuestSpinner"
    })
    if (response.success) {
      setNotification(
        "success",
        <FormattedMessage id="notifications.guestinvitation.successTitle" />,
        <FormattedMessage id="notifications.guestinvitation.successText" />
      )
      return true;
    }
    setNotification(
      "error",
      <FormattedMessage id="notifications.guestinvitation.errorTitle" />,
      <FormattedMessage id="notifications.guestinvitation.errorText" />
    )
    return false
  };

  const checkIfEmailExists = async (payload) => {
    const response = await genericApiFetch({
      url: CHECK_IF_EMAIL_EXISTS_ENDPOINT.replace("{companyEntityID}", companyEntityId).replace("{emailAddress}", payload.emailAddress),
      method: "GET",
      spinner: "inviteGuestSpinner"
    });

    if (response.success) {
      return response.data
    }
  }  

  return {
    safetyResponse,
    mapResponse,
    getFlightDetails,
    getSafetyGridData,
    sendGuestInvite,
    checkIfEmailExists,
    getReservationLinkDetails
  };
}

